import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, unref as _unref, createVNode as _createVNode } from "vue";
const _hoisted_1 = { class: "flex flex-col content-center gap-1" };
const _hoisted_2 = /*#__PURE__*/ _createElementVNode("h3", { style: { "text-wrap": "nowrap" } }, " Your password should be: ", -1);
const _hoisted_3 = {
    key: 0,
    class: "pi pi-check-circle",
    style: { "color": "var(--primary-blue)" }
};
const _hoisted_4 = {
    key: 1,
    class: "pi pi-circle",
    style: { "color": "var(--red-7)" }
};
const _hoisted_5 = { style: { "text-wrap": "nowrap" } };
const _hoisted_6 = {
    key: 0,
    class: "flex flex-col gap-1 mt-4"
};
const _hoisted_7 = /*#__PURE__*/ _createElementVNode("p", null, "Password strength", -1);
import { computed, ref } from 'vue';
import ProgressBar from 'primevue/progressbar';
import { useStringFunctions } from '@apparatix/composables';
export default /*#__PURE__*/ _defineComponent({
    __name: 'PasswordRequirementsFeedback',
    props: {
        rules: {},
        password: {},
        showStrength: { type: Boolean }
    },
    setup(__props) {
        const MEDIUM_STRENGTH_TEST = /^(((?=.*[a-z])(?=.*[A-Z]))|((?=.*[a-z])(?=.*[0-9]))|((?=.*[A-Z])(?=.*[0-9])))(?=.{6,})/;
        const STRONG_STRENGTH_TEST = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})/;
        const { isEmptyString } = useStringFunctions();
        const props = __props;
        const rules = ref(props.rules.map(rule => ({
            message: rule.message,
            passesTest: computed(() => {
                if (!props.password)
                    return false;
                return rule.regex.test(props.password);
            }),
        })));
        const strength = computed(() => {
            if (!props.showStrength)
                return null;
            const isMedium = MEDIUM_STRENGTH_TEST.test(props.password);
            const isStrong = STRONG_STRENGTH_TEST.test(props.password);
            if (isStrong) {
                return {
                    progress: 100,
                    color: '#22c55e',
                };
            }
            if (isMedium) {
                return {
                    progress: 50,
                    color: '#f97316',
                };
            }
            return {
                progress: 10,
                color: '#ef4444',
            };
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _hoisted_2,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rules.value, (rule, idx) => {
                    return (_openBlock(), _createElementBlock("div", {
                        key: idx,
                        class: "flex flex-nowrap gap-2 items-center"
                    }, [
                        (rule.passesTest)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_3))
                            : (_openBlock(), _createElementBlock("span", _hoisted_4)),
                        _createElementVNode("p", _hoisted_5, _toDisplayString(rule.message), 1)
                    ]));
                }), 128)),
                (props.showStrength && !_unref(isEmptyString)(props.password))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                        _hoisted_7,
                        _createVNode(_unref(ProgressBar), {
                            value: strength.value.progress,
                            "show-value": false,
                            pt: { value: { style: { background: strength.value.color } }, root: { style: { height: '0.5rem' } } }
                        }, null, 8, ["value", "pt"])
                    ]))
                    : _createCommentVNode("", true)
            ]));
        };
    }
});
